import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { inject } from '@angular/core';

export const adminGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (
    authService.user?.role?.slug != 'super-admin' &&
    authService.user?.role?.slug != 'admin' &&
    authService.user?.role?.slug != 'mini-admin'
  ) {
    router.navigateByUrl('/');
  }

  return true;
};
